// `template` is the template title from DW3's anonymous preview "Use This
// Template" CTA — it drives AuthTemplateBanner the way `role` drives
// AuthInviteBanner.
//
// `coupon` is a promo code handed over by a marketing page
// (`/billing?coupon=CODE`, DAB-1431). Stashed like `referralCode` so it survives
// the login bounce; BillingCouponLinkModal applies it over the billing page the
// link named once the user is signed in.
const sessionParams = new Set([
  'v',
  'redirect',
  'referralCode',
  'checkout',
  'switch',
  'trial',
  'role',
  'offer',
  'template',
  'coupon',
]);

export function pullSessionFromUrl(url: URL): void {
  const params = url.searchParams;
  let hasAny = false;
  for (const [key, value] of params.entries()) {
    if (!sessionParams.has(key)) continue;
    hasAny = true;
    sessionStorage.setItem(key, value);
  }
  if (!hasAny) return;

  // Strip only the session params; runs inside router.beforeEach so use
  // history.replaceState (location.replace would trigger another navigation).
  for (const key of sessionParams) params.delete(key);
  const query = params.toString();
  const cleaned = url.pathname + (query ? `?${query}` : '') + url.hash;
  history.replaceState(history.state, '', cleaned);
}
